module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable02.1e57f508.png";